export const removeValoresVaziosPayloadTrocaPorNull = (payload) => {
    let newObj = { ...payload }
    Object.keys(newObj).forEach((key) => {
        const value = newObj[key]
        if (typeof value === 'string' && value.trim() === '') {
            newObj[key] = null
        }
    })
    return newObj

}